module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-7-b82f7c146ab44cdd6f8811740eb39a41.svg";